<template>
    <div v-if="json" class="block-featured-games" :class="type">
        <div class="capper">
            <div class="capper-padded" >
                <Lines v-if="type==='top'" type="releases-down" label="Featured Games" label2="Recent Releases" ></Lines>
                <Lines v-if="type==='bottom'" type="releases-up" label="Recent Releases" label2="Featured Games" ></Lines>
                <div class="game-panels" >
                    <div
                        v-for="(item, gIndex) in filteredGames"
                        :key="`game${gIndex}`"
                        class="game-panel"
                        :class="[type, (item?.platforms?.length) ? 'isclickable' : '']"
                        data-aos="fade-up"
                    >
                        <component
                            :is="linkThinker(item) ? 'a' : 'div'"
                            :href="linkGetter(item)"
                            target="_blank"
                            :class="(item?.platforms?.length) ? 'isclickable' : ''"
                            rel="noopener noreferrer"
                            @click="openPlatformsSmarter(item)"
                        >
                            <div class="main-panel">
                                <div class="bgscrim"></div>
                                <div class="content-flex">
                                    <div class="square-padder"></div>
                                    <div class="titles">
                                        <h2 v-if="item.panelTitle" v-html="item.panelTitle"></h2>
                                        <h3 v-if="type==='top' && item.panelBlurb" v-html="gh.nl2br(item.panelBlurb)"></h3>
                                    </div>
                                    <div v-if="type==='top'" class="btns">
                                        <button
                                            :aria-label="getButtonLabel(item.buyNowButtonLabel)"
                                            v-if="item.platforms.length"
                                            class="btn"
                                            @click="openPlatforms(item)"
                                        >
                                            <span class="txt">{{ getButtonLabel(item.buyNowButtonLabel) }}</span>
                                        </button>
                                        <button
                                            aria-label="Play Trailer"
                                            v-if="item.trailerLink"
                                            class="btn"
                                            @click="openYoutube(item.trailerLink)"
                                        >
                                            <span class="txt">TRAILER</span>
                                            <span class="icon">
                                                <VideoPlay/>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="squareimg-outer">
                                <div class="squareimg bgimg" :style="item.panelSquareImage[0].bgStyle"></div>
                            </div>
                        </component>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import gh from '@/helpers/gh'
import VueInlineSvg from "vue-inline-svg";
import Lines from "@/components/pieces/Lines";
import VideoPlay from "@/components/svgs/VideoPlay.vue";
import VideoPlay2 from "@/components/svgs/VideoPlay2.vue";

export default {
    name: "FeaturedGames",
    components: {
        VideoPlay,
        VideoPlay2,
        VueInlineSvg,
        Lines
    },
    props: {
        json: {
            type: Object,
            required: true,
        },
        type: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            gh: gh,
        };
    },
    computed: {
        filteredGames() {
            if (!this.json || !this.json.games) {
                return [];
            }
            // If type is "top", filter games where featured equals "1"
            if (this.type === "top") {
                return this.json.games.filter(game => game.featured === "1");
            }
            // If type is "bottom", filter games where featured is not "1"
            // else if (this.type === "bottom") {
            //     return this.json.games.filter(game => game.featured !== "1");
            // }
            // Otherwise return all games
            return this.json.games;
        }
    },
    methods: {
        linkThinker(gameLink) {
            let ret = false
            if (this.type==='bottom') {
                if (gameLink.platforms?.length === 1) {
                    return true
                }
            }
            return ret
        },
        linkGetter(gameLink) {
            let ret = null
            if (this.type==='bottom') {
                if (gameLink.platforms?.length === 1) {
                    ret = gameLink.platforms?.[0]?.platformLink?.url
                }
            }
            return ret
        },
        openPlatformsSmarter(gameLink) {
            if (this.type==='bottom') {
                if (gameLink.platforms?.length > 1) {
                    this.openPlatforms(gameLink)
                }
            }
        },
        openYoutube(youtubeId) {
            this.$store.commit('openPopup', {youtubeId: youtubeId});
        },
        openPlatforms(gameLink) {
            this.$store.commit('openPopup', {platforms: true, gameLink: gameLink});
        },
        getButtonLabel(lbl) {
            if (!lbl) {
                lbl = "Buy Now"
            }
            return lbl
        }
    },
};
</script>